import { render, staticRenderFns } from "./WarningAlertComponent.vue?vue&type=template&id=2bd8df8a&"
import script from "./WarningAlertComponent.vue?vue&type=script&lang=js&"
export * from "./WarningAlertComponent.vue?vue&type=script&lang=js&"
import style0 from "./WarningAlertComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports